import React from 'react';

export const LoadingIndicator = (props) => (
	<div className="loading-indicator">
		<img 
			src="/images/loading-1.gif"
			alt="Loading indicator"
			aria-hidden="true" />
	</div>
);


// WEBPACK FOOTER //
// ./src/components/LoadingIndicator/LoadingIndicator.js